module.exports = __webpack_public_path__ + "img/softinya-prop-5.d2122b49.png";